var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layer, Link, mergeStyles, Separator, Stack } from '@fluentui/react';
import { Text } from "../components/texts/Text";
import { getPageProps } from '../utils/common';
import { useClasses } from '../utils/useClasses';
import { Branding } from './common/Branding';
var tokens = {
    bannerStacks: {
        childrenGap: 16
    },
    headerStacks: {
        childrenGap: 4
    },
    accessories: {
        childrenGap: 4
    }
};
export var HeaderControl = function (props) {
    var pageProps = getPageProps(props.type);
    var classes = useClasses(function (theme) { return ({
        root: {
            width: '100%',
            backgroundColor: theme.palette.themePrimary,
            alignItems: props.horizontalAlign,
        },
        wrapper: {
            width: '100%'
        },
        content: {
            backgroundColor: theme.palette.themePrimary,
            color: theme.semanticColors.textHeaderTitleForeground,
            lineHeight: 'normal',
            minHeight: '100px',
            maxWidth: pageProps.width,
            width: "100%",
        },
        separator: {
            lineHeight: '36px',
        },
        accessories: {
            alignSelf: "flex-end",
        },
        headerText: {
            color: theme.semanticColors.textHeaderTitleForeground,
            paddingBottom: 0,
        }
    }); });
    var contentClass = mergeStyles([
        props.contentClass,
        classes.content,
    ]);
    return (_jsx(Layer, __assign({ id: "header-root", hostId: props.hostId, className: classes.root }, { children: _jsx(Stack, __assign({ id: "header-wrapper", className: classes.wrapper, horizontalAlign: props.horizontalAlign }, { children: _jsxs(Stack, __assign({ id: "header-content", className: contentClass, horizontal: true, horizontalAlign: 'start', verticalAlign: 'center', tokens: tokens.bannerStacks }, { children: [!props.hideLogo && _jsx(Link, __assign({ target: '_blank', href: props.homeUrl ? props.homeUrl : 'https://go.hashimukh.org/home' }, { children: _jsx(Branding, {}, void 0) }), void 0), !props.hideLogo && _jsx(Separator, { className: classes.separator, vertical: true }, void 0), _jsxs(Stack, __assign({ tokens: tokens.headerStacks }, { children: [_jsx(Text, __assign({ id: "header-content-title", className: classes.headerText, variant: 'xLarge', block: true }, { children: props.title }), void 0), props.subTitle ? _jsx(Text, __assign({ id: "header-content-subtitle", className: classes.headerText, variant: 'medium', nowrap: true }, { children: props.subTitle }), void 0) : null] }), void 0), _jsx(Stack, __assign({ className: classes.accessories, tokens: tokens.accessories, horizontal: true, horizontalAlign: "end", verticalAlign: "end", grow: true }, { children: props.accessories }), void 0)] }), void 0) }), void 0) }), void 0));
};
//# sourceMappingURL=HeaderControl.js.map